import axios from 'axios';
import * as Constants from "../common/constants";
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { OfferFilterSettingsModel } from "../models/offer/offerFilterSettingsModel";
import { OfferAdminModel } from "../models/offer/offerAdminModel";
import { OfferTransferModel } from "../models/offer/offerTransferModel";

class OfferService {
  authService = new AuthService();
  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  getAllOffers(from: number, numberOfRows: number, settings: OfferFilterSettingsModel) {
    return axios({
      url: `offers/getAll/${from}/${numberOfRows}`,
      method: 'post', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(settings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getOffer(id: number) {
    return axios({
      url: `offers/getById/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getAdminOffersList(offerIds: Array<number>) {
    return axios({
      url: `offers/getAdminOffersList`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(offerIds)
      //data: offerIds
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  transferOffer(offerTransfer: OfferTransferModel) {
    return axios({
      url: `offers/transfer`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(offerTransfer)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  addOffer(offer: OfferAdminModel) {
    return axios({
      url: `offers/create`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(offer)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  editOffer(offer: OfferAdminModel) {
    return axios({
      url: `offers/update`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(offer)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  deleteOffer(id: number) {
    return axios({
      url: `offers/delete/${id}`,
      method: 'delete'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default OfferService;
